import { render } from "./TheWatchListSp.vue?vue&type=template&id=34c81daf&scoped=true&ts=true"
import script from "./TheWatchListSp.vue?vue&type=script&lang=ts"
export * from "./TheWatchListSp.vue?vue&type=script&lang=ts"

import "./TheWatchListSp.vue?vue&type=style&index=0&id=34c81daf&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c81daf"]])

export default __exports__